// extracted by mini-css-extract-plugin
export default {"tabMainContainer":"MobileBottomTab_tabMainContainer__ZrSZ+","imageSelected":"MobileBottomTab_imageSelected__Fzs77"};